import { getAuth, EmailAuthProvider, fetchSignInMethodsForEmail } from 'firebase/auth';

export async function supportedEmailLoginMethods(email, method) {
  const methods = {
    'email/password': EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
    'email/link': EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
  };

  if (!Object.keys(methods).includes(method)) {
    console.warn('EMAIL_TYPE not found');
    return false;
  }

  const auth = getAuth();
  const signInMethods = await fetchSignInMethodsForEmail(auth, email);

  return signInMethods.indexOf(methods[method]) !== -1;
}

export default {};
